export default "__VITE_ASSET__DpxuvIKO__"